'use client'

import Link from 'next/link'

import { ContactForm } from '@/components/ContactForm'
import { SectionHeader } from '@/components/SectionHeader'

export default function Page() {
  return (
    <>
      <main className="mb-12 md:mb-20">
        <SectionHeader
          title="Privacy Policy"
          subtitle="個人情報保護方針"
        ></SectionHeader>
        <section className="mt-12 px-lg md:mt-16">
          <div className="mx-auto max-w-3xl text-sm leading-little-loose md:text-base">
            <h3 className="text-base font-semibold md:text-lg">
              特定個人情報等の適正な取扱いに関する基本方針
            </h3>
            <p className="mt-fz-1">
              　税理士法人
              堀口会計（以下「当法人」といいます。）は、個人番号及び特定個人情報（以下「特定個人情報等」といいます。）の適正な取扱いの確保について組織として取り組むために、お客様、取引先及び従業員等の特定個人情報等の保護を重要事項として位置づけ、「特定個人情報等の適正な取扱いに関する基本方針」を以下のとおり定め、代表者、従業員、その他の従業者に周知し、徹底を図ります。
            </p>
            <h4 className="mt-8 font-semibold md:mt-12">
              1. 特定個人情報等の適正な取扱い
            </h4>
            <p className="mt-fz-1">
              当法人のお客様、取引先及び従業員等の特定個人情報等を取得、保管、利用、提供又は廃棄するに当たって、当法人が定めた取扱規程に従い適正に取り扱います。
            </p>
            <h4 className="mt-8 font-semibold md:mt-12">2. 利用目的</h4>
            <p className="mt-fz-1">
              当法人は、特定個人情報等を以下の利用目的の範囲内で取り扱います。
            </p>
            <ol className="mt-fz-1 grid list-[lower-alpha] gap-y-fz-0.5 pl-fz-2">
              <li>
                従業員等に係る源泉徴収事務、社会保険関係事務及び労働保険関係事務
              </li>
              <li>業務委嘱契約等に基づく年末調整事務及び法定調書作成事務</li>
              <li>業務委嘱契約等に基づく税務代理</li>
              <li>業務委嘱契約等に基づく税務書類の作成</li>
              <li>上記 c 及び d に付随して行う事務</li>
            </ol>
            <h4 className="mt-8 font-semibold md:mt-12">
              3. 安全管理措置に関する事項
            </h4>
            <ol className="mt-fz-1 grid list-[lower-alpha] gap-y-fz-0.5 pl-fz-2">
              <li>
                当法人は、特定個人情報等の漏えい、滅失又は毀損の防止等、特定個人情報等の管理のために取扱規程を定め、必要かつ適切な安全管理措置を講じます。また、従業者に特定個人情報等を取り扱わせるに当たっては、特定個人情報等の安全管理措置が適切に講じられるよう、当該従業者に対する必要かつ適切な監督を行います。
              </li>
              <li>
                特定個人情報等の取扱いについて、お客様、取引先及び従業員等の許諾を得て第三者に委託する場合には、十分な特定個人情報保護の水準を備える者を選定するとともに、契約等により安全管理措置を講じるよう定めた上で、委託先に対する必要かつ適切な監督を行います。
              </li>
            </ol>
            <h4 className="mt-8 font-semibold md:mt-12">
              4. 関係法令、ガイドライン等の遵守
            </h4>
            <p className="mt-fz-1">
              当法人は、特定個人情報等に関する法令、特定個人情報保護委員会及び日本税理士会連合会が策定するガイドラインその他の規範を遵守し、全従業者が特定個人情報等の保護の重要性を理解し、適正な取扱い方法を実施します。
            </p>
            <h4 className="mt-8 font-semibold md:mt-12">5. 継続的改善</h4>
            <p className="mt-fz-1">
              当法人は、特定個人情報等の保護が適正に実施されるよう、本基本方針及び当法人内規程類を継続して改善します。
            </p>
            <h4 className="mt-8 font-semibold md:mt-12">6. お問合せ</h4>
            <p className="mt-fz-1">
              当法人は、特定個人情報等の取扱いに関するお問合せに対し、適切に対応いたします。
            </p>
            <p className="mt-fz-3">
              2015年10月1日
              <br />
              <br />
              税理士法人　堀口会計
              <br />
              代表社員　堀口　拓志
            </p>
          </div>
        </section>
      </main>
    </>
  )
}
